<template >
    <v-card 
        flat 
        class="text-none pa-4"
        max-width="300"
    >
        <div
            v-if="data.details"
            class="description-box"
            v-bar="{
                overrideFloatingScrollbar: true,
                observerThrottle: 0,
                draggingPhantomDelay: 0,
                scrollingPhantomDelay: 0,
                resizeRefresh: false
            }"
        >
        <v-list
            dense
            class="listreset detail-list"
        >
            <v-subheader class="pa-0 font-weight-bold black--text h3">
                {{ $t('utils.globalInformation') }}
            </v-subheader>
            <v-list-item v-if="prices">
                <v-card
                    rounded
                    elevation="0"
                    width="100%"
                    class="d-block mb-4 pa-4 price-section"
                >
                    <span
                        v-if="prices.totalPrice"
                        class=" font-weight-bold d-block h4"
                        v-html="prices.totalPrice.text + ' ' + prices.totalPrice.value"
                    />
                    <span
                        v-if="prices.totalPrice.value !== prices.lotPrice.value"
                        class="d-block habiteo-body-4"
                        v-html="prices.lotPrice.text + ' ' + prices.lotPrice.value"
                    />
                    <span
                        v-if="prices.totalPrice.value !== prices.lotPrice.value"
                        class="d-block habiteo-body-4"
                        v-html="prices.annexPrice.text + ' ' + prices.annexPrice.value"
                    />
                </v-card>
            </v-list-item>
            <v-list-item
                v-for="(item, index) in globalInfo"
                :key="`detail-${index}`"
                class="pa-0"
                :class=" { 'plot-description': item.id === 'description'}"
                v-show="item.id !== 'name' && item.value"
            >
                {{ item.label }}
                <span
                    :style="{ 'color': item.color }"
                    v-html="getDescription(item)"
                />
            </v-list-item>
            <v-list-item v-if="tags">
                <div class="tag-list">
                    <div
                        v-for="(tag, tagName) in tags.tags"
                        :key="tag.id + tagName"
                        class="tag"
                        :style="{ 'background-color': tag.color }"
                    >
                        <label class="cursor">
                            {{ tagName }}
                        </label>
                    </div>
                </div>
            </v-list-item>
        </v-list>
        <v-list
            v-if="metrics"
            class="pt-8"
        >
            <v-subheader class="pa-0 pb-2 font-weight-bold black--text h4">
                {{ $t('utils.metricInformation') }}
            </v-subheader>
            <v-list-item
                v-for="(metric, metricName) in metrics.metrics"
                :key="metric.id + metricName"
            >
                {{ metricName }} :<span class="pl-2" v-html="decodeHTMLfromString(metric)"/>
            </v-list-item>
        </v-list>
    </div>
    </v-card>   
</template>

<script>
    export default{
        name: 'InformationDialog',
        data: () => ({
            pricesDetails: [
                'totalPrice',
                'lotPrice',
                'annexPrice'
            ],
            skippedDetails: [
                'metrics',
                'name'
            ],
        }),
        props:[
            'data',
            'showInformationPopup',
        ],
        computed:{
            prices() {
                const priceList = this.data.details ? this.data.details.filter(detail => this.pricesDetails.includes(detail.id)) : [];
                var prices = null;
                if (priceList.length) {
                    prices = {};
                    priceList.forEach(price => {
                        prices[price.id] = {
                                'text': price.label,
                                'value': price.value
                            };
                    });
                }
                return prices;
            },
            globalInfo() {
                const globalInfo = this.data.details ? this.data.details.filter(detail => !this.skippedDetails.includes(detail.id) && !this.pricesDetails.includes(detail.id)) : [];
                return globalInfo.length ? globalInfo : null;
            },
            tags() {
                const tags = this.data.details ? this.data.details.find(detail => detail.id === 'tags') : null;
                return tags ? tags : null;
            },
            metrics() {
                const metrics = this.data.details ? this.data.details.find(detail => detail.id === 'metrics') : null;
                return metrics ? metrics : null;
            }
        },
        methods: {
            closeDialog(){
                this.$emit('close');
            },
            decodeHTMLfromString(str){
                let decoder = document.createElement('textarea');
                decoder.innerHTML = str;
                return decoder.value;
            },
            getDescription(item) {
                switch (item.id) {
                    case 'description':
                        return this.decodeHTMLfromString(item.value);
                    case 'surface':
                    case 'surface_annex':
                        return item.unit ? item.value + ' ' + item.unit : item.value;
                    default:
                        return item.value;
                }
            },
        },
    }
</script>

<style lang='scss' scoped>
    div.v-list.detail-list {
        > .v-list-item {
            min-height: unset;
        }
    }
</style>


// WEBPACK FOOTER //
// src/layout/alternative/plot/components/InformationDialog.vue